import React from 'react'
import './BannerMainTop.css'
import Grid from '@mui/material/Grid'
import styled from 'styled-components'
import { devices } from 'utils/screen_sizes'
import { CardContent, Hidden, Typography } from '@material-ui/core'
import { isMobile } from 'utils'
const StyledCard = styled.div`
    box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
        0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    overflow: hidden;
    background-color: ${(props) => (props.bg ? props.bg : '')};
    display: flex;
    flex-direction: row;
    padding: 1rem;
    border-radius: 8px;

    @media ${devices.mobileS} {
        flex-direction: column-reverse;
        align-items: center;
        padding: 0rem; //new
    }
    @media ${devices.laptop} {
        flex-direction: row;
        align-items: start;
        // padding: -1rem;
    }

    .MuiCardContent-root {
        flex: 1;
    }

    h5 {
        color: ${(props) => (props.titlecolor ? props.titlecolor : '#fff')};
        font-family: 'playfair-bold';

        @media ${devices.mobileS} {
            font-size: 1.1rem; //new
        }
        @media ${devices.mobileM} {
            font-size: 1.1rem; //new
        }
        @media ${devices.laptop} {
            font-size: 1.5rem; //new
        }
    }

    img {
        width: 200px;
        height: 300px;
        object-fit: contain;

        @media ${devices.mobileS} {
            margin-bottom: 0;
            margin-left: 0;
            width: 100%;
            /* height: 145px; */
            height: 95px; //new
            margin-top: 1rem;
        }
        @media ${devices.mobileM} {
            margin-bottom: 0;
            margin-left: 0;
            margin-top: 1rem;
            width: 100%;
            height: 115px;
        }
        @media ${devices.laptop} {
            margin-bottom: -7rem;
            margin-left: 1rem;
            width: 200px;
            height: 300px;
            margin-top: 0;
        }
    }
`

const StyledTypography = styled.h6`
    color: ${(props) =>
        props.descriptioncolor ? props.descriptioncolor : '#fff'};
    font-size: 14px;
    font-weight: normal;
    font-family: 'open-sans';
    text-transform: capitalize;

    @media ${devices.mobileS} {
        margin: 0.5rem 0 2rem 0rem;
        font-size: 12px; //new
    }
    @media ${devices.laptop} {
        margin: 0.5rem 0 2rem 0rem;
        font-size: 14px;
    }
`

export const BannerMainTop = () => {
    return (
        <div style={{ marginTop: '-5rem' }}>
            <Grid
                container
                spacing={3}
                style={{
                    width: 'calc(100% + 48px)',
                    background: '#000',
                    height: '378px',
                }}
            >
                {/* <Grid item xs={12}></Grid> */}
                <Grid item xs={12} sm={12} md={12}>
                    <div titlecolor={''} style={{ marginTop: '-8px' }}>
                        {/* <picture>
                            <source
                                media="(min-width: 650px)"
                                srcset="/assets/images/Mobile-Banner-Trade-In.png"
                            />
                            <source
                                media="(min-width: 465px)"
                                srcset="/assets/images/Mobile-Banner-Trade-In.png"
                            />
                            <img
                                className="modile-img"
                                src={
                                    '/assets/images/Trade-In-Samsung-Banner.png'
                                }
                                alt="main banner"
                            />
                        </picture> */}
                        {console.log(isMobile())}
                        {isMobile() ? (
                            <img
                                className="modile-img"
                                src={
                                    '/assets/images/Mobile-Banner-Trade-In.png'
                                }
                                alt="main banner"
                            />
                        ) : (
                            <img
                                className="modile-img"
                                src={
                                    '/assets/images/Trade-In-Samsung-Banner.png'
                                }
                                alt="main banner"
                            />
                        )}
                    </div>
                </Grid>
            </Grid>
        </div>
    )
}
